import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $LogoImg = styled('img')`
  min-height: ${spacing(5)};
  max-height: ${spacing(11)};
  max-width: 100%;
  object-fit: contain;
`;
